/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Applications_Empty_SubtitleInputs */

const en_applications_empty_subtitle = /** @type {(inputs: Applications_Empty_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply to a job to start tracking your progress here.`)
};

const de_applications_empty_subtitle = /** @type {(inputs: Applications_Empty_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewirb dich auf eine Stelle, um deinen Fortschritt hier zu verfolgen.`)
};

const fr_applications_empty_subtitle = /** @type {(inputs: Applications_Empty_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postule à un emploi pour commencer à suivre ta progression ici.`)
};

const es_applications_empty_subtitle = /** @type {(inputs: Applications_Empty_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postúlese a un empleo para empezar a seguir su progreso aquí.`)
};

const it_applications_empty_subtitle = /** @type {(inputs: Applications_Empty_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Candidati per un lavoro per iniziare a monitorare i tuoi progressi qui.`)
};

const nl_applications_empty_subtitle = /** @type {(inputs: Applications_Empty_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solliciteer op een baan om hier je voortgang bij te houden.`)
};

const pl_applications_empty_subtitle = /** @type {(inputs: Applications_Empty_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyślij aplikację, aby rozpocząć śledzenie postępów tutaj.`)
};

const fi_applications_empty_subtitle = /** @type {(inputs: Applications_Empty_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hae työpaikkaa aloittaaksesi edistymisen seurannan.`)
};

const da_applications_empty_subtitle = /** @type {(inputs: Applications_Empty_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansøg til et job for at begynde at spore din fremgang her.`)
};

const sv_applications_empty_subtitle = /** @type {(inputs: Applications_Empty_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansök till ett jobb för att börja spåra din framgång här.`)
};

/**
* | output |
* | --- |
* | "Apply to a job to start tracking your progress here." |
*
* @param {Applications_Empty_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const applications_empty_subtitle = /** @type {((inputs?: Applications_Empty_SubtitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Applications_Empty_SubtitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_applications_empty_subtitle(inputs)
	if (locale === "fr") return fr_applications_empty_subtitle(inputs)
	if (locale === "es") return es_applications_empty_subtitle(inputs)
	if (locale === "it") return it_applications_empty_subtitle(inputs)
	if (locale === "nl") return nl_applications_empty_subtitle(inputs)
	if (locale === "pl") return pl_applications_empty_subtitle(inputs)
	if (locale === "fi") return fi_applications_empty_subtitle(inputs)
	if (locale === "da") return da_applications_empty_subtitle(inputs)
	if (locale === "sv") return sv_applications_empty_subtitle(inputs)
	return en_applications_empty_subtitle(inputs)
});